var Particles = (function(){

    function Particles(){
        THREE.Object3D.call(this);

        var geometry = new THREE.Geometry();
        var vertex;
        for (i = 0; i < 50000; i++) {
            vertex = new THREE.Vector3();
            vertex.x = Math.random() * 500 - 250;
            vertex.y = Math.random() * 500 - 250;
            vertex.z = Math.random() * 500 - 250;
            geometry.vertices.push(vertex);
        }

        var material = new THREE.PointCloudMaterial({size: 0.5, color: 0xFFFFFF});

        this.particles = new THREE.PointCloud(geometry, material);
        this.particles2 = new THREE.PointCloud(geometry, material);
        
        this.add(this.particles);
        this.add(this.particles2);

    }

    Particles.prototype = new THREE.Object3D;
    Particles.prototype.constructor = Particles;

    Particles.prototype.update = function() {
        this.particles.rotation.y += 0.001;
        this.particles2.rotation.y += 0.0005;
    };

    return Particles;
})();